import { useAuthGetLearningSessionQueryQuery } from './get-learning-session.v5.generated';

/**
 * Get the learning user session data
 */
export const useLearningSession = () => {
  const { data, loading, error, refetch } = useAuthGetLearningSessionQueryQuery(
    {
      context: {
        clientName: 'v5',
      },
      fetchPolicy: 'no-cache',
    },
  );

  const learningSession = data?.security?.current_session?.learning_session;
  const learningSessionData =
    learningSession?.organization_id && learningSession?.user_id
      ? {
          userLearningId: learningSession.user_id,
          organizationLearningId: learningSession.organization_id,
        }
      : undefined;

  return {
    learningSessionData,
    loading,
    error,
    refetch,
  };
};
